module.exports = __webpack_public_path__ + "img/login.d332f24d.jpg";